import { Button, Image, Stack, Text } from "@bookingcom/bui-react";
import { t, useI18n } from "@bookingcom/lingojs-react";

type UserManagementErrorStateProps = {
  onRetry: () => void;
};

export const UserManagementErrorState = ({ onRetry }: UserManagementErrorStateProps) => {
  const i18n = useI18n();

  return (
    <Stack alignItems="center" justifyContent="center" gap={4} mixin={{ paddingBlockStart: 16 }}>
      <Image
        asset={{
          setName: "illustrations-partner-thumbnails",
          assetName: "RegistrationReviewRejected",
        }}
        width={80}
      />
      <Stack alignItems="center" gap={1}>
        <Text variant="strong_1">
          {i18n.trans(t("flights_airline_portal_user_management_page_error_header"))}
        </Text>
        <Text variant="body_2" color="neutral_alt">
          {i18n.trans(t("flights_airline_portal_user_management_page_error_subheader"))}
        </Text>
      </Stack>
      <Button variant="primary" onClick={onRetry}>
        {i18n.trans(t("flights_airline_portal_airline_view_campaign_error_api_failure_button"))}
      </Button>
    </Stack>
  );
};
